DepartmentRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function DepartmentRouting($urlRouterProvider, $stateProvider) {

    $urlRouterProvider.otherwise("/Department/Dashboard");

    $stateProvider

        .state('Department', {

            abstract: true,

            url: '/Department',

            template: '<ui-view id="Department"></ui-view>'

        })

        .state('Department.Dashboard', {

            url: '/Dashboard',

            controller: 'Department.DashboardController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./Dashboard/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./Dashboard/Dashboard.module');

                        $ocLazyLoad.load({

                            name: 'DashboardModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "پردیس",
                icon: "fas fa-building"
            }

        })
        .state('Department.MemberList', {

            url: '/MemberList',

            controller: 'Department.MemberListController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./MemberList/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./MemberList/MemberList.module');

                        $ocLazyLoad.load({

                            name: 'MemberListModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Department.Dashboard",
                title: " لیست اعضا",
                icon: "fas fa-tasks"
            }

        })
        .state('Department.DepartmentList', {

            url: '/DepartmentList',

            controller: 'Department.DepartmentListController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./DepartmentList/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./DepartmentList/DepartmentList.module');

                        $ocLazyLoad.load({

                            name: 'DepartmentListModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Department.Dashboard",
                title: "لیست مجتمع ها",
                icon: "fas fa-tasks"
            }

        })
        .state('Department.AddMember', {

            url: '/AddMember',

            controller: 'Department.AddMemberController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./AddMember/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./AddMember/AddMember.module');

                        $ocLazyLoad.load({

                            name: 'AddMemberModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Department.MemberList",
                title: "اضافه نمودن عضو",
                icon: "fas fa-plus"
            }

        })


        .state('Department.RequestReceivedFromMember', {

            url: '/RequestReceivedFromMember',

            controller: 'Department.RequestReceivedFromMemberController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./RequestReceivedFromMember/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./RequestReceivedFromMember/RequestReceivedFromMember.module');

                        $ocLazyLoad.load({

                            name: 'RequestReceivedFromMemberModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Department.Dashboard",
                title: "درخواست های دریافتی",
                icon: "fas fa-user"
            }

        })

        .state('Department.MyMembership', {

            url: '/MyMembership',

            controller: 'Department.MyMembershipController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./MyMembership/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./MyMembership/MyMembership.module');

                        $ocLazyLoad.load({

                            name: 'MyMembershipModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Department.Dashboard",
                title: "لیست عضویت های من",
                icon: "fas fa-id-card-alt"
            }

        })
        .state('Department.RequestReceivedFromDepartment', {

            url: '/RequestReceivedFromDepartment',

            controller: 'Department.RequestReceivedFromDepartmentController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./RequestReceivedFromDepartment/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./RequestReceivedFromDepartment/RequestReceivedFromDepartment.module');

                        $ocLazyLoad.load({

                            name: 'RequestReceivedFromDepartmentModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Department.Dashboard",
                title: " درخواست های دریافتی از مجتمع ها",
                icon: "fas fa-building"
            }

        })
        .state('Department.ListOfRequests', {

            url: '/ListOfRequests',

            controller: 'Department.ListOfRequestsController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./ListOfRequests/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./ListOfRequests/ListOfRequests.module');

                        $ocLazyLoad.load({

                            name: 'ListOfRequestsModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Department.Dashboard",
                title: " درخواست های ارسال شده شما",
                icon: "fas fa-building"
            }


	})
  .state('Department.PardisManagement',{

  url: '/PardisManagement',

  controller: 'Department.PardisManagementController',

  controllerAs: 'self',

  templateProvider: ['$q', ($q) => {

      return $q((resolve) => {

          require.ensure([], () => {

              let template = require('./PardisManagement/views/index.html');

              resolve(template);

          });

      });

  }],

  resolve: {

      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

        let deferred = $q.defer();

        require.ensure([], function () {

            let module = require('./PardisManagement/PardisManagement.module');

            $ocLazyLoad.load({

                name: 'PardisManagementModule',

            });

            deferred.resolve(module);

        });

        return deferred.promise;

      }]

  },
  breadcrumbData: {
    parent: "Department.Dashboard",
    title: "پردیس های من",
    icon: "fas fa-city"
}


    })/*endOfResolve*/ ;

}



export default DepartmentRouting;
